import { render } from "./EditQualificationMembership.vue?vue&type=template&id=6d973a32"
import script from "./EditQualificationMembership.vue?vue&type=script&lang=js"
export * from "./EditQualificationMembership.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__